import lazyLoadView from "@router/lazyload-view";
import routeError from "@router/route-error";
import store from '@store'

export default [
  // 業務洽詢
  {
    path: '/contact',
    name: 'contact',
    component: () => lazyLoadView(import('@views/Contact/Contact')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next({ name: 'inquiry' })
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "contact",
      title: '聯絡我們'
    },
  },
  // 業務洽詢
  {
    path: '/contact/inquiry',
    name: 'inquiry',
    component: () => lazyLoadView(import('@views/Contact/Contact')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('option/fetchOptionList', {
            types: ['brand'],
            useCached: true
          });
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "inquiry",
      title: '業務洽詢'
    },
  },
  // 聯絡銷售人員
  {
    path: '/contact/contact-sales',
    name: 'contactSales',
    component: () => lazyLoadView(import('@views/Contact/ContactSales')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const currentBrands = await store.dispatch('brand/fetchBrands')
          routeTo.params.brands = currentBrands
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "contact-sales",
      title: '聯絡銷售人員'
    },
    props: (route) => ({
      brands: route.params.brands
    })
  },
  // 營業據點
  {
    path: '/contact/location',
    name: 'location',
    component: () => lazyLoadView(import('@views/Contact/Location')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('global/fetchMenu')
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "location",
      title: '營業據點'
    },
  },
  // 維護報修
  {
    path: '/contact/repair',
    name: 'repair',
    component: () => lazyLoadView(import('@views/Contact/Repair')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('global/fetchMenu')
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "repair",
      title: '維護報修'
    },
  },
  // 申請成為經銷商 2022/11/01 取消
  // {
  //   path: '/contact/tobeDealer',
  //   name: 'tobeDealer',
  //   component: () => lazyLoadView(import('@views/Contact/TobeDealer')),
  //   meta: {
  //     async beforeResolve(routeTo, routeFrom, next) {
  //       try {
  //         const profileData = await store.dispatch('auth/fetchUser')
  //         console.log('profileData :>> ', profileData);
  //         routeTo.params.profile = profileData
  //         next()
  //       } catch (error) {
  //         console.log('error :>> ', error);
  //         routeError(error, routeTo, next({ name: '404' }));
  //       }
  //     },
  //     title: '申請成為經銷商'
  //   },
  //   props: (route) => ({
  //     profile: route.params.profile || {},
  //   })
  // },
  // 其他詢問
  {
    path: '/contact/inquiryOther',
    name: 'inquiryOther',
    component: () => lazyLoadView(import('@views/Contact/ContactOther')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          await store.dispatch('global/fetchMenu')
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: "inquiryOther",
      title: '其他詢問'
    },
  },
  // 聯絡我們 手機版選單
  {
    path: '/contact/menu',
    name: 'contact-menu',
    component: () => lazyLoadView(import('@views/MobilePageMenu/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const vw = document.body.clientWidth
          if (vw > 676) {
            next({ name: 'inquiry' });
          }
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      alias: 'contact',
      title: '聯絡我們'
    },
  },
]
